<template>
  <div :style="{width, height}">
    <slot />
  </div>
</template>

<script>
export default {
  name: "Bloco",
  props: {
    width: {
      type: String,
      required: true
    },
    height: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
